"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVisible = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var useVisible = function useVisible(ref) {
  var rootMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0px';

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  (0, _react.useEffect)(function () {
    var el = ref.current;
    var observer;

    if (window.IntersectionObserver) {
      // eslint-disable-next-line compat/compat
      observer = new IntersectionObserver(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 1),
            entry = _ref2[0];

        return setVisible(entry.isIntersecting);
      }, {
        rootMargin: rootMargin
      });

      if (el) {
        observer.observe(el);
      }
    } else {
      // No support for InteractionObserver, default to true
      setVisible(true);
    }

    return function () {
      if (observer) {
        observer.unobserve(el);
      }
    };
  }, [ref, rootMargin]);
  return visible;
};

exports.useVisible = useVisible;


//////////////////
// WEBPACK FOOTER
// ./js/utils/hooks/useVisible.js
// module id = 890
// module chunks = 209 210 211 212